interface TermsModalProps {
  onClose: () => void;
}

export default function TermsModal({ onClose }: TermsModalProps) {
  const domain = 'kiedycogdzie.pl';
  const contactEmail = `${domain}@gmail.com`;
  // const bankAccountNumber = '85 1140 2004 0000 3002 8580 8391'; // used by the paid events section, currently disabled below

  const closeButtonClassName =
    'absolute top-[8px] right-[8px] z-[2147483647] inline-flex h-6 w-6 items-center justify-center rounded-full border text-white';

  return (
    <div
      id="terms-modal-overlay"
      className="fixed top-0 left-0 z-[2147483646] flex h-screen w-screen items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Regulamin"
    >
      <div className="absolute inset-0 bg-black/45" onClick={onClose} aria-hidden="true" />

      <div
        id="terms-modal"
        className="relative w-[min(96vw,60rem)] max-h-[90vh] overflow-hidden rounded-2xl text-slate-100 shadow-[0_20px_60px_rgba(5,8,20,0.55)] backdrop-blur-md"
        // bg-[rgba(22,26,45,0.72)]
        //border
        // border-white/25
        onClick={(event) => event.stopPropagation()}
      >
        <button
          id="terms-modal-close"
          type="button"
          className={closeButtonClassName}
          onClick={onClose}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(11, 1, 54, 0.24)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#ea580c';
          }}
          style={{
            backgroundColor: '#ea580c',
            borderColor: '#ffffff',
            color: '#ffffff',
            width: '24px',
            height: '24px',
            minWidth: '24px',
            minHeight: '24px',
            padding: '0',
            lineHeight: '1',
          }}
          aria-label="Zamknij okno regulaminu"
        >
          <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
            <line x1="1" y1="1" x2="9" y2="9" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            <line x1="9" y1="1" x2="1" y2="9" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
          </svg>
        </button>

        <div
          id="terms-modal-content"
          className="max-h-[calc(90vh-2rem)] overflow-y-auto px-6 pb-6 pt-10 text-sm leading-relaxed text-slate-100 md:px-8"
        >
          <h3 className="mb-4 text-lg font-semibold uppercase text-slate-100">Regulamin serwisu</h3>
          <p className="mb-4 text-xs text-slate-400">Ostatnia aktualizacja: 20 sierpnia 2026 r.</p>
          <p className="mb-4">
            Kontakt biznesowy:{' '}
            <a href={`mailto:${contactEmail}`} className="popup-yellow-link underline underline-offset-2">
              {contactEmail}
            </a>
            .
          </p>

          <h4 className="mb-2 mt-5 text-base font-semibold uppercase">§1. Czym jest serwis {domain}?</h4>
          <p className="mb-4">
            Serwis {domain} to interaktywna mapa prezentująca lokalizacje wydarzeń kulturalnych, muzycznych
            i rozrywkowych na terenie Polski. Celem serwisu jest ułatwienie użytkownikom odnajdywania interesujących
            wydarzeń w ich okolicy.
          </p>

          <h4 className="mb-2 mt-5 text-base font-semibold uppercase">§2. Kim jesteśmy</h4>
          <p className="mb-2">
            Jesteśmy nowym serwisem i tworzymy go społecznie, pro publico bono, bez wynagrodzenia. Prosimy
            o wyrozumiałość, jeśli coś nie zadziała od razu tak, jak powinno.
          </p>
          <p className="mb-4">
            Jeśli podoba Ci się projekt i chcesz go wesprzeć, będzie nam bardzo miło. Błędy prosimy zgłaszać na
            adres e-mail podany w §6 — odpowiemy i naprawimy je w miarę naszych możliwości czasowych. Planujemy
            rozwijać serwis o kolejne funkcje, np. alerty o nowych wydarzeniach pasujących do wybranej frazy.
          </p>

          <h4 className="mb-2 mt-5 text-base font-semibold uppercase">§3. Logowanie do serwisu</h4>
          <p className="mb-4">
            Logowanie jest dostępne wyłącznie dla administratorów i moderatorów serwisu. Jeśli chcesz zostać
            moderatorem, napisz do nas na adres e-mail podany w §6 i pozostawaj aktywny na naszym Discordzie.
          </p>

          <h4 className="mb-2 mt-5 text-base font-semibold uppercase">§4. Dodawanie darmowych wydarzeń</h4>
          <p className="mb-2">
            Dodawanie do serwisu wydarzeń z <strong>bezpłatnym wstępem</strong> jest całkowicie <strong>bezpłatne</strong>.
            Każdy użytkownik może zgłosić takie wydarzenie za pomocą formularza dostępnego na stronie głównej.
          </p>
          <p className="mb-2">
            Zgłaszane wydarzenie musi być prawdziwe i rzeczywiście planowane lub odbywające się. Formularz
            wymaga podania tytułu, opisu oraz pozostałych wymaganych pól. Opis powinien być krótki, zwięzły
            i rzeczowy — nie akceptujemy rozległych opisów.
          </p>
          <p className="mb-4">
            Zgłoszone wydarzenia są weryfikowane przez moderatorów serwisu przed ich publikacją na mapie.
            Zastrzegamy sobie prawo do odrzucenia zgłoszenia, które nie spełnia wymogów regulaminu lub jest
            niezgodne z tematyką serwisu.
          </p>

          {/* Paid/ticketed events section - disabled for now, may be reinstated later.
          <h4 className="mb-2 mt-5 text-base font-semibold uppercase">§5. Dodawanie wydarzeń biletowanych i płatnych</h4>
          <p className="mb-2">
            Dodawanie wydarzeń <strong>biletowanych lub płatnych</strong> (wydarzeń, na które wymagane jest nabycie
            biletu lub uiszczenie opłaty wstępu) wiąże się z <strong>opłatą w wysokości 100 zł</strong> za każde
            takie zgłoszenie.
          </p>
          <p className="mb-2">
            Proces dodania płatnego wydarzenia wygląda następująco:
          </p>
          <ol className="mb-4 list-decimal pl-5 space-y-1 text-slate-300">
            <li>
              Wypełnij formularz dodawania wydarzenia, odznaczając opcję „Wstęp wolny".
            </li>
            <li>
              System automatycznie wygeneruje unikalne <strong>ID zgłoszenia</strong> (np. <span className="font-mono">EVT-XXXXXXXX</span>).
            </li>
            <li>
              Dokonaj przelewu w wysokości 100 zł na numer konta:{' '}
              <span className="font-mono font-bold text-white">{bankAccountNumber}</span>,
              wpisując ID zgłoszenia w tytule przelewu.
            </li>
            <li>
              Po zweryfikowaniu płatności moderatorzy opublikują Twoje wydarzenie na mapie.
            </li>
          </ol>
          <p className="mb-4">
            Opłata jest bezzwrotna w przypadku odrzucenia zgłoszenia z powodu naruszenia regulaminu.
            W przypadku błędu technicznego po stronie serwisu zwrot zostanie dokonany w ciągu 14 dni roboczych.
          </p>
          */}

          <h4 className="mb-2 mt-5 text-base font-semibold uppercase">§5. Zasady korzystania z serwisu</h4>
          <ul className="mb-4 list-disc pl-5 space-y-1 text-slate-300">
            <li>Zabrania się dodawania treści niezgodnych z prawem, obraźliwych lub wprowadzających w błąd.</li>
            <li>Każde zgłoszenie powinno dotyczyć rzeczywiście planowanego lub odbywającego się wydarzenia.</li>
            <li>Zabrania się wielokrotnego zgłaszania tego samego wydarzenia.</li>
            <li>Administrator może usunąć wydarzenie bez podania przyczyny, jeśli narusza ono regulamin.</li>
          </ul>

          <h4 className="mb-2 mt-5 text-base font-semibold uppercase">§6. Kontakt</h4>
          <p className="mb-4">
            W razie pytań lub wątpliwości dotyczących regulaminu, prosimy o kontakt pod adresem e-mail:{' '}
            <a
              href={`mailto:${contactEmail}`}
              className="popup-yellow-link underline underline-offset-2"
            >
              {contactEmail}
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
